import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["status"];
  static values = { prompt: String };

  connect() {
    this.defaultTitle = this.element.title;
    this.reset();
  }

  disconnect() {
    window.clearTimeout(this.resetTimeout);
  }

  reset() {
    window.clearTimeout(this.resetTimeout);
    this.statusTarget.hidden = true;
    this.statusTarget.textContent = "";
    this.element.title = this.defaultTitle;
  }

  async copy() {
    if (!this.hasPromptValue) return;

    try {
      await navigator.clipboard.writeText(this.promptValue);
      this.showStatus("Copied");
    } catch {
      this.showStatus("Copy failed");
    }
  }

  showStatus(status) {
    this.statusTarget.textContent = status;
    this.statusTarget.hidden = false;
    this.element.title = status;
    window.clearTimeout(this.resetTimeout);
    this.resetTimeout = window.setTimeout(() => this.reset(), 1500);
  }
}
